import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Body } from "../../Certificates";
import { HelmetTitle } from "../../../Components/Utils";
import Layout from "../../../Components/Layout";
import Navbar from "../../BannerItems/Components/Navigation";
import Banner from "../../Certificates/Components/Banner";

import BannerBig from "../../../Images/min-1600-hero.jpg";
import BannerSmall from "../../../Images/max-600-hero.jpg";
import MachineLearningMD from "../Contents/MachineLearning.md";
import "../index.css";



class MachineLearningPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const name = "Machine learning";
    return (
      <div className="App">
        <HelmetTitle title="Machine learning" />
        <Layout
          head={
            <Navbar />
            }
          body={
            <React.Fragment>
              <Banner certName={name} imgPathMin={BannerBig} imgPathMax={BannerSmall} />
              <Body name={name} markdownPath={MachineLearningMD} />
            </React.Fragment>
          }
        />
      </div>
    );
   }    
}

export default withRouter(MachineLearningPage)



// WEBPACK FOOTER //
// ./src/Pages/Misc/Pages/MachineLearning.js